<template>
  <div id="videodetail" v-if="loaded">
    <div class='vedio-inner'>
      <video v-bind:class="{hide:showvip}" id="myVideo" v-bind:src="video.video" webkit-playsinline="true" x-webkit-airplay="true" playsinline="true" controls x5-playsinline x5-video-player-fullscreen="true"></video>
      <div style="width:100%;background-color:#000000;text-align:center;" v-bind:class="{show:vipgeting}" class="getbox">
        <img v-on:click="event_getstart" src="../assets/1.png" style="width:10vw;height:10vw;margin:auto;vertical-align:middle;display:inline-block;" /></div>
      </div>
    <div class='vedio-info'>
      <!--<div class='h3'>{{video.subject}}</div>
      <div class='date'>
      <div>
      <div class="iconfont icon-rili"></div>
      {{video.create_at}}
      </div>
      <div>
      <div class="iconfont icon-eye"></div>
      {{video.view}}
      </div>
      </div>-->
      <!--<div v-html="video.content"></div>-->
      <div class="vedio_title">
        <div>
          <h3>{{video.subject}}</h3>
          <div class="gz" v-on:click="setFollow();" v-if="isfollow==false">
            <i class="iconfont icon-jia"></i>关注</div>
          <div class="gz" v-if="isfollow">已关注</div></div>
        <div style="margin-top: 10px;line-height: 26px;">
          <em>￥{{uservideolevel.price}}</em>&nbsp&nbsp(付款后永久有效)
          <span>
            <i>播放 {{video.view}}</i>
            <i>关注 {{video.concern_number}}</i>
          </span>
        </div>
      </div>
      <div class="vedio_js">
        <p>
          <div v-html="video.content"></div>
        </p>
      </div>
    </div>
    <div class="vedio_gl"></div>
    <div class="vedio_plbox">
      <div class="vedio_pltitle">
        <h4>评论&nbsp;({{video.comment_number}})</h4></div>
      <div class="vedio_pllist">
        <ul>
          <li v-for="(item,idx) in commentList">
            <div class="pl_yh">
              <div class="pl_tx">
                <span>
                  <img :src="item.avatar" /></span>{{item.nickname}}</div>
              <div class="pl_pf">
                <i v-bind:class="{blue:item.scorevlaue > 0}" class="iconfont icon-pingfen"></i>
                <i v-bind:class="{blue:item.scorevlaue > 1}" class="iconfont icon-pingfen"></i>
                <i v-bind:class="{blue:item.scorevlaue > 2}" class="iconfont icon-pingfen"></i>
                <i v-bind:class="{blue:item.scorevlaue > 3}" class="iconfont icon-pingfen"></i>
                <i v-bind:class="{blue:item.scorevlaue > 4}" class="iconfont icon-pingfen"></i>
              </div>
            </div>
            <p>{{item.content}}</p>
            <em>{{item.create_at}}&nbsp;</em></li>
          <div class="pl_more">
            <a>{{tips}} </a>
          </div>
        </ul>
      </div>
    </div>
    <div class="foot_pl">
		<span class="" style="display: inline-block;width: 50px;text-align: center;">评分</span>
		<div class="pl_sr">
			<i class="iconfont icon-pingluncopyx"></i>
			<input v-model="content" type="text" name="" id="" value="" placeholder="说些啥..." v-on:click="showpf();" />
		</div>
		<div class="pl_fb" style="margin-left: 10px;margin-right: 10px;text-align:center;">
			<a v-on:click="addComment();" style="height:30px;color:#FFFFFF;text-align:center;line-height:30px;">发表</a>
		</div>
		<div class="pf" v-if="isshow">您对本视频的评价：
			<i v-bind:class="{blue:this.scorevlaue > 0}" class="iconfont icon-pingfen" v-on:click="setScorevlaue(1);"></i>
			<i v-bind:class="{blue:this.scorevlaue > 1}" class="iconfont icon-pingfen" v-on:click="setScorevlaue(2);"></i>
			<i v-bind:class="{blue:this.scorevlaue > 2}" class="iconfont icon-pingfen" v-on:click="setScorevlaue(3);"></i>
			<i v-bind:class="{blue:this.scorevlaue > 3}" class="iconfont icon-pingfen" v-on:click="setScorevlaue(4);"></i>
			<i v-bind:class="{blue:this.scorevlaue > 4}" class="iconfont icon-pingfen" v-on:click="setScorevlaue(5);"></i>&nbsp;&nbsp;&nbsp;{{scorevname}}
		</div>
	</div>
    <div class='more-tuijian' v-if="video.relevants.length">
      <div class='title'>相关推荐</div>
      <div class='tuijian' v-for="item in video.relevants">
        <div class='left' v-on:click="event_detail(item)">
          <img v-bind:src="item.image" mode="widthFix" />
          <div class='vedio-bg'></div>
          <div class="iconfont icon-bofang"></div>
        </div>
        <div class='right'>
          <div class='h3'>{{item.subject}}</div>
          <div class='jianjie'>{{item.description}}</div>
          <button v-on:click="event_detail(item)">立即观看</button></div>
      </div>
    </div>
    <div class="vipbox" v-bind:class="{show:showvip}">
      <div class="content" style="height:40vw;">
        <div class="center" style="margin-top:7vw;">
          <div>播放结束，请付费查看完整视频。</div></div>
        <router-link to="/videovip">
          <div class="button" v-on:click="event_buy">去购买</div></router-link>
      </div>
    </div>
    <div class="back_box" @click="goTo('/')">
      <a  class="iconfont icon-fanhuishouye"></a>
    </div>
  </div>
</template>
<script>export
default {
    name:
    'Videodetail',
    data() {
      return {
        loaded: false,
        video: {},
        uservideolevel: {},
        isfollow: {},
        windowWidth: 0,
        showvip: false,
        vipgeting: false,
        t: 0,
        l: 0,
        scorevlaue: 5,
        name: ['很不好', '不好', '一般', '好', '很好'],
        scorevname: '',
        isshow: false,
        content: '',
        commentList: [],
        pageindex: 0,
        pagesize: 5,
        REQUIRE: true,
        tips: '努力加载中...'
      }
    },
    created() {
      this.scorevname = this.name[this.scorevlaue - 1];
      //评论
      this.loadComment(true);

    },
    computed: {
},
    mounted() {

		var that = this

		var options = this.$route.query;


		this.$app.pr('/api/video/detail', {

			id: options.id

		}).then((res) =>{

			this.video = res.data.video;

			this.$app.pr('/api/common/jsparams',{

				url:that.$wx.getUrls()

			}).then((res) => {

				wx.config(res.data.shareparam);

				try{

					wx.ready(function(){
						wx.onMenuShareAppMessage({

							title:that.video.subject,

							desc:that.video.description,

							link:'https://jk.ioccn.com/videodetail?id='+options.id+'&scene=sell_'+that.$store.state.userInfo.id,

							imgUrl:that.video.image,

							success:function(){}

						});

						wx.onMenuShareTimeline({

							title: that.video.subject,

							link: 'https://jk.ioccn.com/videodetail?id='+options.id+'&scene=sell_'+that.$store.state.userInfo.id,

							imgUrl: that.video.image
						});
					});
				}catch(e){alert('fx error'+e)}

			});

			this.uservideolevel = res.data.uservideolevel;

			this.isfollow = res.data.isfollow;

			this.loaded = true;

			setTimeout(function() {

				try {

					console.log(111);
					$('#myVideo')[0].play();

					$('#myVideo')[0].ontimeupdate = function() {

						if (that.$store.state.userInfo.user_video_level_id || that.video.free || that.$store.state.config.data.updateing == '1') {

							return false

						} else {

							var t = parseInt($('#myVideo')[0].currentTime);

							that.t = t

							if (t >= parseInt(that.$store.state.config.data.video_fee_time)) {

								$('#myVideo')[0].pause();

								that.showvip = true

							}

						}

					}

				} catch(e) {

				}

			},
1000);

		}).
catch((res) =>{

			this.$wx.navigateBack({

				delta: 1

			})


		});

		// 添加滚动事件，检测滚动到页面底部
		window.addEventListener('scroll', this.scrollBottom)
    },
    methods: {
      scrollBottom() {
        // 滚动到页面底部时
        if (((window.screen.height+document.documentElement.scrollTop) >= (document.body.clientHeight)) && this.REQUIRE) {

          this.loadComment(false);
        }
      },
      setData(params) {
        for (var n in params) {
          this[n] = params[n]
        }
      },
      event_detail: function(item) {
        this.$wx.navigateTo({
          url: '/videodetail?id=' + item.id,
        })
      },
      event_buy() {

},
      event_getstart() {

},
      setScorevlaue(index) {
        this.scorevlaue = index;
        this.scorevname = this.name[this.scorevlaue - 1];
      },
      setFollow() { //关注
        var options = this.$route.query;
        this.$app.pr('/api/Videofollow/add', {
          videoid: options.id
        }).then((res) =>{
          this.$wx.showToast('关注成功！');
          this.isfollow = true;
        }).
        catch((res) =>{
          this.$wx.showToast('关注失败！');
        });
      },

      goTo(path) {
        this.$wx.navigateTo({
          url: path,
        })
      },
      addComment() { //发布评论
        if (this.content == '') {
          this.$wx.showToast('请输入您要发布的内容！');
          return;
        }

        this.$wx.showLoading();
        var options = this.$route.query;
        this.$app.pr('/api/Videocomment/add', {
          videoid: options.id,
          content: this.content,
          scorevlaue: this.scorevlaue,
          scorename: this.scorevname,
          videotitle: this.video.subject
        }).then((res) =>{
          this.$wx.hideLoading();
          this.loadComment(true);
          this.content = '';
          this.video.comment_number = this.video.comment_number + 1;
          this.$wx.showToast('发布成功！');

        }).
        catch((res) =>{
          this.$wx.showToast('发布失败！');
          this.$wx.hideLoading();
        });
      },
      showpf() {
        this.isshow = true;
      },
      loadComment(isfirst) {
        if (isfirst) { //判断是否是首次加载
          this.pageindex = 1;
          this.commentList = [];
          this.REQUIRE = true;
        }
        var options = this.$route.query;
        this.tips = '努力加载中...';
        //评论
        this.$app.pr('/api/Videocomment/getcomment', {
          videoid: options.id,
          pageindex: this.pageindex,
          pagesize: this.pagesize
        }).then((res) =>{
          if (res.success) {
            if (res.data.datalist.length > 0) {
              for (var i = 0; i < res.data.datalist.length; i++) {
                this.commentList.push(res.data.datalist[i]);
              }

              this.tips = '';
            } else {
              this.REQUIRE = false;
              if (isfirst) {
                this.tips = '暂无评论';
              } else {
                this.tips = '没有更多了';
              }
            }
          }
        }).
        catch((res) =>{
          console.log(res);
        });
        this.pageindex++;
      }
    }
  }</script>
<style scoped>
	.back_box{
  	width: 35px;
  	height: 35px;
  	border-radius: 100%;
  	background-color: #1accf9;
  	position: fixed;
  	right: 20px;
  	bottom: 80px;
  }
  .back_box a{
  	font-size: 16px;
  	color: #fff;
  	text-align: center;
  	line-height: 35px;
  	display: block;
  }
  #videodetail{ background-color:#ffffff; min-height:100vh; padding-bottom: 60px; } .video{ width:100%; } video{ z-index:1; } .vedio-inner{ position:relative; height:56vw; } .vedio-inner video{ width:100%; display:block; position:absolute; z-index:1; left:0px; top:0px; height:56vw; } .vedio-cover{ width:100%; height:100%; position:absolute; left:0px; top:0px; z-index:1000; } .vedio-inner{ position: relative; } .vedio-inner image{ width: 100%; height: 55vw; } .vedio-inner .vedio-bg{ position: absolute; top: 0; border-radius: 5px; left: 0; background: #000; width: 100%; height: 98%; opacity: 0.3 } .vedio-inner .icon-bofang{ position: absolute; left: 50%; color: #fff; width: 30px; height: 30px; margin-left: -15px; margin-top: -15px; top: 50%; font-size: 40px; } .vedio-info{ background: #fff; padding:3vw; } .vedio-info .vedio_title{ padding-bottom: 10px; border-bottom: 1px solid #eee; } .vedio-info .vedio_title div{ overflow: hidden; color: #ccc; } .vedio-info .vedio_title div h3{ font-size: 4.7vw; color: #333; float: left; width: 80%; } .vedio-info .vedio_title div .gz{ background-color: #1accf9; color: #fff; font-size: 3.5vw; border-radius: 4px; float: right; padding: 3px 8px; } .vedio-info .vedio_title div .gz i{ font-size: 3.5vw; margin-right: 2px; } .vedio-info .vedio_title div em{ font-size: 4vw; color: #1accf9; } .vedio-info .vedio_title div span{ float: right; color: #ccc; font-size: 3.5vw; } .vedio-info .vedio_title div span i:first-child{ margin-right: 10px; } .vedio-info .vedio_js{ font-size: 4vw; line-height: 1.8; color: #666; margin-top: 10px; } .vedio_gl{ height: 10px; background-color: #f6f6f6; margin-top: 10px; } .vedio_plbox .vedio_pltitle{ border-bottom: 1px solid #eee; } .vedio_plbox .vedio_pltitle h4{ font-size: 4.2vw; padding: 3vw; color: #333; } .vedio_plbox .vedio_pllist{ padding: 3vw; } .vedio_plbox .vedio_pllist ul li{ border-bottom: 1px solid #eee; overflow: hidden; padding-bottom: 10px; } .vedio_plbox .vedio_pllist ul li .pl_yh{ overflow: hidden; } .vedio_plbox .vedio_pllist ul li .pl_yh .pl_tx{ overflow: hidden; line-height: 40px; font-size: 4vw; color: #333; float: left; } .vedio_plbox .vedio_pllist ul li .pl_yh .pl_tx span{ width: 40px; height: 40px; border-radius: 100%; display: block; float: left; margin-right: 10px; } .vedio_plbox .vedio_pllist ul li .pl_yh .pl_tx span img{ width: 100%; } .vedio_plbox .vedio_pllist ul li .pl_yh .pl_pf{ float: right; position: relative; width: 102px; height: 40px; overflow: hidden; } .vedio_plbox .vedio_pllist ul li .pl_yh .pl_pf .pf_bg,.vedio_plbox .vedio_pllist ul li .pl_yh .pl_pf .pf_bg1{ position: absolute; top: 50%; left: 0; width: 100%; transform: translateY(-50%); } .vedio_plbox .vedio_pllist ul li .pl_yh .pl_pf .pf_bg img,.vedio_plbox .vedio_pllist ul li .pl_yh .pl_pf .pf_bg1 img{ width: 100%; } .vedio_plbox .vedio_pllist ul li .pl_yh .pl_pf .pf_bg1{ left: -21px; } .vedio_plbox .vedio_pllist ul li p{ font-size: 3.5vw; padding-left: 50px; color: #666; margin-top: 6px; } .vedio_plbox .vedio_pllist ul li em{ float: right; color: #bbb; margin-top: 10px; } .vedio_plbox .vedio_pllist .pl_more{ font-size: 4vw; color: #1accf9; text-align: center; margin-top: 10px; } .foot_pl{ display: flex; height: 50px; justify-content: space-around; align-items: center; border-top: 1px solid #eee; width: 100%; position: fixed; bottom: 0; left: 0; background-color: #fff; } .foot_pl span{ font-size: 4vw; } .foot_pl .active{ color: #1accf9; } .foot_pl .pl_sr{ width: 230px; background-color: #eee; position: relative; border-radius: 4px; } .foot_pl .pl_sr i{ position: absolute; top: 50%; transform: translateY(-50%); left: 6px; color: #bbb; } .foot_pl .pl_sr input{ border: 0; line-height: 30px; width: 100%; background-color: #eee; outline: 0; padding-left: 26px; color: #999; border-radius: 4px; padding-right: 10px; } .foot_pl .pl_sr ::-webkit-input-placeholder{ color: #999; } .foot_pl .pl_fb{ width: 60px; border-radius: 4px; background-color: #1accf9; } .foot_pl .pl_fb input{ border: 0; outline: 0; background-color: #1accf9; width: 100%; line-height: 30px; color: #fff; border-radius: 4px; } .foot_pl .pf{ position: absolute; top: -50px; left: 0; width: 100%; height: 50px; background: rgba(0,0,0,.4); padding: 0 3vw; line-height: 50px; color: #fff; font-size: 3.5vw; } .foot_pl .pf i{ color: #fff; margin: 0 2px; } .foot_pl .pf i.blue{ color: #1accf9; } .pl_pf i.blue{ color: #1accf9; } .vedio-info .h3{ font-size: 4.7vw; color: #626262; } .vedio-info .date{ display: flex; color: #999; border-bottom: 1px dashed #dedede; margin-top: 10px; padding-bottom: 10px; font-size: 12px; } .vedio-info .date div{ margin-right: 10px; display: flex; } .vedio-info .date .iconfont{ vertical-align: middle; margin-top: 5px; } .vedio-info .date .icon-rili{ background:url(http://jk.ioccn.com/jiakao/icon-rili.png) no-repeat; width: 15px; height: 15px; margin-top: 0; } .vedio-info .date .icon-eye{ background:url(http://jk.ioccn.com/jiakao/icon-eye.png) no-repeat; width: 17px; height: 10px; } .vedio-info .miaoshu{ margin-top: 10px; font-size: 14px; line-height: 24px; color: #666; text-indent: 10px; } .more-tuijian{ margin-top: 10px; background: #fff; } .more-tuijian .title{ padding: 3vw; font-size:4.7vw; border-bottom:1px solid #dedede; } .tuijian{ display: flex; padding: 3vw; } .tuijian .left{ position: relative; width: 30vw; margin-right: 3vw; } .tuijian .left .vedio-bg{ position: absolute; top: 0; border-radius: 5px; left: 0; background: #000; width: 30vw; height: 30vw; opacity: 0.3 } .tuijian .left image{ width: 100%; height: 30vw; } .tuijian .left .icon-bofang{ position: absolute; left: 50%; color: #fff; width: 30px; height: 30px; margin-left: -15px; margin-top: -15px; top: 50%; font-size: 30px; } .tuijian .right{ width: 61vw; } .tuijian .right .h3{ font-size: 15px; max-height: 6vw; line-height: 6vw; overflow: hidden; height:6vw; } .tuijian .right .jianjie{ margin-top: 5px; color: #999; height: 12vw; line-height: 6vw; overflow: hidden; font-size: 14px; } .tuijian .right button{ background: #f38400; font-size:12px; color:#fff; float:right; margin-top:2vw; height:8vw; line-height:8vw; text-align:center; } .vipbox{ width:100vw; height:100vh; background-color:rgba(0, 0, 0, 0.76); position:fixed; z-index:100000; left:0px; top:0px; display:none; } .vipbox.show{ display:block; } .vipbox .content{ width:86vw; position:absolute; background-color:#FFFFFF; border-radius:4vw; top:50%; left:50%; height:70vw; margin-top:-35vw; margin-left:-43vw; } .vipbox .content .top{ width:100%; height:38vw; background-image:url('http://jk.ioccn.com/jiakao/video_vip.png'); background-size:auto 100%; background-position:center center; background-repeat:no-repeat; margin-top:-18vw; } .vipbox .content .center{ text-align:center; font-size:4.6vw; line-height:7.5vw; margin-top:10vw; color:#f38400; } .vipbox .content .button{ width:78vw; height:12vw; background-color:#f38400; margin:8vw auto 0vw; border-radius:2vw; color:#FFFFFF; font-size:4.6vw; text-align:center; line-height:12vw; }
  .getbox{ display:none; position:absolute; left:0px; top:0px; z-index:99999; } .getbox.show{ display:block; } .co{ background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAABAklEQVRYhe2Wvw5EQBCHZ/FKGjqJQkJFJZ5TpfOnQkGh8xgKCXNcMskVcpbj9i7ZL5lud+fL7PoFAwAEwSiiBVakBCElCClBSAmCW2IcR+j7HqIoAk3TLhdBnnqlbVsMw5BrH2cdlyC6rsMgCFBVVXESRNM06Ps+MsbESazM84x1XaPneeIkXqmqCl3XPTKZ6yVoMkVRoG3bu2czMtljOZdn2eY+RXmfBLeF1TIJiOMYdF3nWn/5dSRJgqZpfv9hTtP0bG4YhpivI01TtCzrbEacl1hff57nnzY/L5FlGTqOc0XzYxLDMGBZls/mH8TzZnHnxJ3810/NnUgJQkoQPyHxALCMwYtqJEmeAAAAAElFTkSuQmCC); } .getbox cover-view{ background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAABAklEQVRYhe2Wvw5EQBCHZ/FKGjqJQkJFJZ5TpfOnQkGh8xgKCXNcMskVcpbj9i7ZL5lud+fL7PoFAwAEwSiiBVakBCElCClBSAmCW2IcR+j7HqIoAk3TLhdBnnqlbVsMw5BrH2cdlyC6rsMgCFBVVXESRNM06Ps+MsbESazM84x1XaPneeIkXqmqCl3XPTKZ6yVoMkVRoG3bu2czMtljOZdn2eY+RXmfBLeF1TIJiOMYdF3nWn/5dSRJgqZpfv9hTtP0bG4YhpivI01TtCzrbEacl1hff57nnzY/L5FlGTqOc0XzYxLDMGBZls/mH8TzZnHnxJ3810/NnUgJQkoQPyHxALCMwYtqJEmeAAAAAElFTkSuQmCC); } video.hide{ display:none }</style>



// WEBPACK FOOTER //
// src/components/Videodetail.vue